import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name getFclOverweightContainer
 * @description Calculate total number of overweight containers only
 * when FCL Shipping Containers is used on Form page.
 *
 * @param {Redux.Store} getState - Whole redux Store State
 * @returns {number}
 *
 * @example
 * console.log(getFclOverweightContainer(getState)); //2
 */
export const getFclOverweightContainer = (getState) => {
  let tempFclShipping = getState().form.fclShipping || {};
  // make fclShipping object to array
  let tempFclShippingArr = [];
  if (!isEmpty(tempFclShipping)) {
    let keys = Object.keys(tempFclShipping).filter(
      (key) => tempFclShipping[key] && key
    );

    keys.map((key) => tempFclShippingArr.push(tempFclShipping[key]));
  }
  let totalOverweightContaine = 0;
  tempFclShippingArr.map((itemObj) => {
    if (itemObj.isOverweight) {
      let tempInput = Number(itemObj.input);
      tempInput = isNaN(tempInput) ? 0 : tempInput;
      totalOverweightContaine = totalOverweightContaine + tempInput;
    }
  });
  // console.log(totalOverweightContaine);
  return totalOverweightContaine;
};
